import {nonBlank} from "../../libs/utils/epic.utils";

export class BankAddressDto {

  public id!: string;
  public ownerName!: string;
  public iban!: string;
  public ibanFormated!: string;
  public bankName: string | undefined;
  public bic: string | undefined;
  public prime!: boolean;
  public label: string | undefined;

  constructor(init?: Partial<BankAddressDto> | undefined) {
    Object.assign(this, init);
  }

  public getHiddenIbanFormated(): string {
    if (nonBlank(this.ibanFormated)) {
      return this.ibanFormated.replaceAll(/\d|\w/gi, '*');
    }
    return '';
  }

  public get maskIban(): string {
    if (nonBlank(this.iban)) {
      const ibanRegex = /^([A-Z]{2}[0-9]{2})([A-Z0-9]{1,30})$/;
      if (ibanRegex.test(this.iban)) {
        return this.iban.replace(/(.{4})(.*)(.{4})/, '$1****$3');
      }
    }
    return '';
  }
}
